<template>
  <scoped v-if="value">
    <div class="column">
      <EnumerationPicker
        v-if="orderTypes"
        v-model:selection="value.type"
        :options="orderTypes"
        :readOnly="readOnly"
        title="Type"
      />
      <EnumerationPicker
        v-if="orderStatuses"
        v-model:selection="value.status"
        :options="orderStatuses"
        :readOnly="readOnly"
        title="Status"
      />
      <TextInput
        v-model:value="value.reference"
        title="Reference"
        :readOnly="readOnly"
      />
      <TextInput
        v-model:value="value.memorandum"
        title="Memorandum"
        :readOnly="readOnly"
        multiline
      />
    </div>
    <div class="column">
      <DateInput
        v-model:value="value.billedAt"
        title="Billed At"
        :readOnly="readOnly"
      />
    </div>
    <div class="column">
      <TextInput
        v-model:value="value.currency"
        title="Currency"
        :readOnly="readOnly"
      />
      <CheckboxButton
        v-model:value="value.shiftedVAT"
        title="Shift VAT"
        :readOnly="readOnly"
      />
      <EnumerationPicker
        v-model:selection="value.discountType"
        :options="['FIXED', 'RATE', 'SUBTRACTION']"
        :readOnly="readOnly"
        title="Discount Type"
      />
      <NumberInput
        v-model:value="value.discountValue"
        title="Discount Value"
        :readOnly="readOnly"
      />
    </div>
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import CheckboxButton from "@/components/checkbox_button.vue"
  import DateInput from "@/components/inputs/date.vue"
  import TextInput from "@/components/inputs/text.vue"
  import NumberInput from "@/components/inputs/number.vue"
  import {onBeforeMount, PropType, ref} from "vue"
  import {Order} from "@/endpoints/rutsolve/gql/generated/graphql"
  import EnumerationPicker from "@/components/selectors/enumeration.vue"
  import {Enumeration as EnumerationClient} from "@/endpoints/rutsolve/gql/resolvers/enumeration"
  import ErrorModal from "@/components/modals/error.vue"

  defineProps({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  })

  onBeforeMount(() => {
    read()
  })

  const error = ref<Error>(null)
  const enumerationClient = new EnumerationClient()
  const orderStatuses = ref<string[]>(null)
  const orderTypes = ref<string[]>([
      "PURCHASE_CREDIT",
      "PURCHASE_DEBIT",
      "PURCHASE_OFFER"
  ])
  const value = defineModel("value", {
    default: null,
    required: true,
    type: Object as PropType<Order>
  })

  async function read() {
    try {
      const response = await enumerationClient.readOrderEnumerations()
      orderStatuses.value = response.statuses
    } catch(e) {
      error.value = e
    }
  }
</script>

<style scoped>
  .column {
    display: inline-block;
    margin: 0 1em 1em 0;
    vertical-align: top;
  
    &:last-child {
      margin-right: 0;
    }
  }
</style>
